import { render } from "./InvestasiDetailKBLI.vue?vue&type=template&id=4315d743"
import script from "./InvestasiDetailKBLI.vue?vue&type=script&lang=js"
export * from "./InvestasiDetailKBLI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__